window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const isUS =
      Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[0] ===
      "America";
  
    if (isUS) {
      const [number] = document.getElementsByClassName("pledge-content_number");
      number.innerHTML = "1000";
    }
  
    // create a reusable effect that swaps text
    gsap.registerEffect({
      name: "swapText",
      effect: (targets, config) => {
        const tl = gsap.timeline({
          delay: config.delay,
          scrollTrigger: {
            trigger: ".pledge-section_overlay",
            start: "60% bottom",
          },
        });
        tl.to(targets, { opacity: 0, duration: config.duration / 2 });
        tl.add(() => (targets[0].innerText = config.text));
        tl.to(targets, { opacity: 1, duration: config.duration });
        return tl;
      },
      defaults: { duration: 1 },
      extendTimeline: true,
    });
  
    // Video reveal animation
    gsap.to(".pledge-section_overlay", {
      opacity: 0,
      scrollTrigger: {
        trigger: ".pledge-section_overlay",
        start: "60% bottom",
      },
      duration: 2,
      onComplete: () => {
        const video = document.getElementById("pledge-video");
        video.play();
      },
    });
  
    // Degree count animation
    gsap.from(".pledge-content_number", {
      textContent: isUS ? "0ºF" : "0ºC",
      ease: "power1.in",
      snap: { textContent: 1 },
      scrollTrigger: {
        trigger: ".pledge-section_overlay",
        start: "60% bottom",
        delay: 2,
      },
      duration: 6,
      stagger: {
        each: 1.0,
        onUpdate: function () {
          this.targets()[0].innerHTML = `${Math.ceil(
            this.targets()[0].textContent
          )}º${isUS ? "F" : "C"}`;
        },
      },
    });
  
    // Pledge text update
    gsap.effects.swapText(".pledge-title", {
      text: "Do your bit to help",
      delay: 4,
    });
    gsap.effects.swapText(".pledge-title", {
      text: "",
      delay: 6,
    });

  }, 500)
});
